// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14Cf3","footer":"Footer_footer__rzbiM","rotate":"Footer_rotate__3c196"};